import { escapeHtml } from './escapeHtml';
import type { SerializeOptions } from './serializeOptions';
import { serializeText } from './serializeText';
import type { CastInlineContent } from '../types';

export function serializeInline(node: CastInlineContent, options: SerializeOptions): string {
  switch (node.type) {
    case 'link': {
      const inner = node.children.map(child => serializeInline(child, options)).join('');
      return options.emitLinks ? `<a href="${escapeHtml(node.href)}">${inner}</a>` : inner;
    }
    case 'selectionEnd':
      return '<selection-end/>';
    case 'selectionStart':
      return '<selection-start/>';
    case 'text':
      return serializeText(node, options);
  }
}
